import {
  BrowseSorting,
  getSortings,
  SortingValuesEnum,
} from '../../models/sorting';

export class SortingState {
  videoSorting: BrowseSorting = getSortings().find(
    (s) => s.value === SortingValuesEnum.Recent
  );
  playlistSorting: BrowseSorting = getSortings().find(
    (s) => s.value === SortingValuesEnum.Recent
  );
  gpsSorting: BrowseSorting = getSortings().find(
    (s) => s.value === SortingValuesEnum.Recent
  );
  workoutSorting: BrowseSorting = getSortings().find(
    (s) => s.value === SortingValuesEnum.Recent
  );
  coachingSorting: BrowseSorting = getSortings().find(
    (s) => s.value === SortingValuesEnum.Recent
  );
  searchedContentSorting: BrowseSorting = getSortings().find(
    (s) => s.value === SortingValuesEnum.Recent
  );
}
